/**
 * Pure helpers for the CreateAssessment KPI composer's local state.
 *
 * The composer keeps KPIs flat: rows with `parent_kpi_id` are sub-KPIs,
 * rows without are top-level. Server payloads are nested trees, so we
 * flatten on load and submit-shape on save.
 */

/**
 * Nested server tree → flat local rows. Sub-KPIs get their parent's
 * `kpi_id` in `parent_kpi_id`. Self-referential edges are dropped.
 */
export function flattenFromServerTree(nested, kpiCatalog) {
  const out = [];
  for (const parent of nested) {
    out.push({
      id: parent.kpi_id,
      title: parent.kpi_title || kpiCatalog[parent.kpi_id] || "",
      is_mandatory: !!parent.is_mandatory,
      weightage:
        parent.weightage_override != null
          ? String(parent.weightage_override)
          : null,
      default_weightage: parent.default_weightage ?? null,
      parent_kpi_id: null,
    });
    for (const child of parent.sub_kpis || []) {
      if (child.kpi_id === parent.kpi_id) continue;
      out.push({
        id: child.kpi_id,
        title: child.kpi_title || kpiCatalog[child.kpi_id] || "",
        is_mandatory: !!child.is_mandatory,
        weightage:
          child.weightage_override != null
            ? String(child.weightage_override)
            : null,
        default_weightage: child.default_weightage ?? null,
        parent_kpi_id: parent.kpi_id,
      });
    }
  }
  return out;
}

/**
 * Flat local rows → server submit shape. `display_order` follows array
 * order. Blank weightage becomes `undefined` so the server falls through
 * to the KPI's default.
 */
export function flattenForSubmit(kpis) {
  return kpis.map((k, idx) => ({
    kpi_id: k.id,
    display_order: idx,
    is_mandatory: !!k.is_mandatory,
    weightage:
      k.weightage === null || k.weightage === undefined || k.weightage === ""
        ? undefined
        : Number(k.weightage),
    parent_kpi_id: k.parent_kpi_id ?? undefined,
  }));
}
